<template>
  <div class="hy-people">
    <!--嘉宾详情-->
    <div class="people_info">
      <div class="top">
        <div class="textbox" style="padding-top:0px;">
          <h5 class="hy_name">{{newInfo.name}}</h5>
          <p class="hy_ssapid">媒体 : {{newInfo.source}} 作者： {{newInfo.author}} </p>
          <span class="miaoshu" v-if="newInfo.summary != null">描述：{{newInfo.summary}}</span>
        </div>
      </div>
      <div class="infobox">
        <div class="infotext" v-html="newInfo.text_content"></div>
      </div>
    </div>
    <!--底部按钮-->
    <div class="hy-fixed-userBtn">
      <span class="iconfont fixed-link" @click="openFooterNav()">&#xe60c;</span>
      <div class="hy_footer_nav" :class="footerNav? 'active':''">
        <router-link class="nav-link iconfont" to="/">&#xe60e; <span class="text">会议平台首页</span></router-link>
        <router-link class="nav-link iconfont" to="/myEnroll">
          &#xe609;
          <span class="text">我的会议信息</span>
        </router-link>
      </div>
    </div>
    <template v-if="Object.keys(newInfo).length != 0">
         <footerFixed :id="newInfo.conference_id" :jump-page="newInfo.jump_page" />
    </template>

  </div>
</template>


<script>
  import footerFixed from  '@/components/common/fixed_setting'
  export default {
    components: {
      footerFixed
    },
    data() {
      return {
        id: '',
        newInfo: {},
        loading: false,
        finished: false,
        footerNav: false,
      };
    },
    created() {
      var _this = this;
      _this.id = _this.$route.params.id;
      _this.$toast.loading({
        message: '加载中...',
        forbidClick: true,

      });
      setTimeout(function() {
        _this.$toast.clear();
      }, 500)
    },
    methods: {
      //banner跳转方法
      goPath(path) {
        if (path == '') {
          return false;
        }
        this.$router.push(path)
      },
      //搜索方法
      onSearch(val) {
        this.$toast(val);
      },
      addList() {
        var _this = this;
        this.$get('/ac1/conference/newsDetail', {
          id: _this.id,
          page: 1,
          pagesize: 10
        }).then(res => {
          _this.newInfo = res.posts;
        })
      },
      //打开底部链接
      openFooterNav(val) {
        //   this.$toast(val);
        if (this.footerNav) {
          this.footerNav = false;
        } else {
          this.footerNav = true;
        }
      },
    },
    mounted() {
      this.addList();
    }
  }
</script>
<style lang="less" scoped>

</style>
